import { render } from "./AddMenuset.vue?vue&type=template&id=565af7ba&scoped=true"
import script from "./AddMenuset.vue?vue&type=script&lang=js"
export * from "./AddMenuset.vue?vue&type=script&lang=js"

import "./AddMenuset.vue?vue&type=style&index=0&id=565af7ba&scoped=true&lang=css"

import exportComponent from "/var/www/html/minty.crm.frontend.merchant/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-565af7ba"]])

export default __exports__